export const getApplicationById = (state, id) => {
  const { applications } = state;

  if (applications[id]) {
    return applications[id];
  }

  return null;
};

export const getApplications = ({ applications }) => {
  return applications;
};
